<!-- VizbiPlus section wrapper; content migrated from legacy/Plus/Plus/ -->

<template>
  <div class="plus-heading">
    <h3>
      <router-link to="/Plus" title="VizbiPlus home">VizbiPlus</router-link>
    </h3>
    <nav>
      <router-link v-for="item in navItems" :key="item.path" :to="item.path">
        {{ item.label }}
      </router-link>
    </nav>
  </div>
  <router-view />
</template>

<script setup>
const navItems = [
  {path: "/Plus/Challenge", label: "Challenge"},
  {path: "/Plus/People", label: "People"},
  {path: "/Plus/Events", label: "Events"},
  {path: "/Plus/Timeline", label: "Timeline"},
  {path: "/Plus/About", label: "About"},
  {path: "/Plus/Contact", label: "Contact"}
];
</script>

<style scoped>
.plus-heading {
  margin-bottom: 1.5rem;
}
h3 {
  display: inline;
}
nav {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem 1.2rem;
  margin-top: 0.6rem;
}
nav a {
  font-size: 0.9rem;
  white-space: nowrap;
}
nav a.router-link-exact-active {
  font-weight: 600;
  text-decoration: none;
}
</style>
